import { usePostHttp } from "../../http.hook";
import type { IOtp } from "../../../../types/models/otp.models.types";

interface IBody {
  id: string;
}

interface IOtpResponse extends IOtp {}

export function useVerifyPhoneResendOtpBrandHttp() {
  return usePostHttp<IBody, IOtpResponse>({
    path: "/brand/profile/phone/otp/resend",
  });
}
